import React from "react";

import {
  CenterContainer,
  VBoxHBox,
  ActivableLink,
  MarginContainer,
  Image,
  Text,
} from "@liro_u/react-components";

import { ScaleMove } from "@liro_u/react-animation-components";

import { handleProp, routes } from "@liro_u/cms-front";

import { useLanguageContext } from "@liro_u/cms-front";
import { usePageRatioContext } from "@liro_u/cms-front";

const ProjectPreview = ({
  backgroundColor = "#251e34",
  name = { fr: "default title", en: "" },
  _id,
  image = {
    editorType: "language",
    fr: {
      editorType: "imageSelector",
      value:
        "https://firebasestorage.googleapis.com/v0/b/liro-u.appspot.com/o/GUI%2Fplaceholder%2Fplaceholder.png?alt=media&token=499319ad-3327-4f5c-84cb-b44027484cfe",
      title: "placeholder.png",
    },
    en: {
      editorType: "imageSelector",
      value: "",
      title: "",
    },
  },
  project = {},
  style,
  ...content
}) => {
  const { language } = useLanguageContext();
  const { pageRatio } = usePageRatioContext();

  const getImageProp = () => {
    const acc = {};
    handleProp(image, acc, "image", { language });
    return acc.image;
  };

  const vboxHboxStyle = {
    borderRadius: "30px 0",
    backgroundColor: backgroundColor,
    overflow: "hidden",
  };

  return (
    <div className="projectPreview" {...content} style={style}>
      <ScaleMove mode="onHover" scaleEnd={1.1} time={0.5}>
        <ActivableLink to={routes.page + "/" + _id} disabled={!_id}>
          <VBoxHBox
            mainBoxStyle={pageRatio === "tel" ? vboxHboxStyle : {}}
            style={pageRatio === "tel" ? {} : vboxHboxStyle}
            vbox={pageRatio === "tel"}
          >
            <Image
              width={_id ? (pageRatio === "tel" ? "100%" : "30%") : 0}
              height={_id ? (pageRatio === "tel" ? "20vh" : "auto") : 0}
              src={typeof image === "string" ? image : getImageProp()}
            />
            <MarginContainer
              margin={"30px"}
              style={{
                flexGrow: 2,
              }}
            >
              <CenterContainer>
                <Text
                  text={name[language] ? name[language] : name["fr"]}
                  fontWeight="bold"
                  fontSize={pageRatio === "tel" ? "20px" : "40px"}
                  color="var(--light-color)"
                />
              </CenterContainer>
            </MarginContainer>
          </VBoxHBox>
        </ActivableLink>
      </ScaleMove>
    </div>
  );
};

export default ProjectPreview;
